import {
  FluentProvider,
  PartialTheme,
  Spinner,
  SpinnerProps,
  webDarkTheme,
  webLightTheme,
} from "@fluentui/react-components";


interface SpinnerCustomProps {
  rcName?: string;
  theme?: string;
}

const SpinnerCustom = (props: SpinnerCustomProps & SpinnerProps) => {
  const renderTheme: PartialTheme =
    props.theme === "dark" ? webDarkTheme : webLightTheme;
  return props.theme ? (
    <FluentProvider
      theme={
        props.theme === "dark"
          ? webDarkTheme
          : {
            ...renderTheme,
            colorBrandBackground: "rgb(70, 101, 136)",
            colorBrandBackgroundHover: "rgb(21, 51, 89)",
          }
      }
    >
      <Spinner {...props} />
    </FluentProvider>
  ) : <Spinner {...props} />;
};

export default SpinnerCustom;
